var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "data-page-header" }, [
        _c("div", { staticClass: "d-flex" }, [
          _c("img", {
            staticClass: "back-to-list-apps",
            attrs: { src: require("@/assets/icon/arrow-left.svg") },
            on: {
              click: function($event) {
                _vm.$router.push("/form-data")
              }
            }
          }),
          _vm._v(" "),
          _c("h3", { staticClass: "data-page-header-title ellipsis" }, [
            _vm._v(
              _vm._s(
                _vm.dataGroup ? _vm.dataGroup.name : "Table Group Not Found"
              )
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-flex" },
          [
            _c("b-form-input", {
              ref: "filterInput",
              staticClass: "text-search-data",
              attrs: { placeholder: "Search Table" },
              model: {
                value: _vm.filter_data,
                callback: function($$v) {
                  _vm.filter_data = $$v
                },
                expression: "filter_data"
              }
            }),
            _vm._v(" "),
            _c("i", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.viewOnly || _vm.isAdmin,
                  expression: "!viewOnly || isAdmin"
                }
              ],
              staticClass:
                "fa fa-lg fa-plus font-weight-bold cursor-pointer m__t--10 m__l--10",
              attrs: { id: "addPopover" }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "action-select-data" }, [
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showCheckboxExportTable,
                  expression: "showCheckboxExportTable"
                }
              ],
              on: { click: _vm.selectAll }
            },
            [_vm._v("Select All")]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showCheckboxExportTable,
                  expression: "showCheckboxExportTable"
                }
              ],
              staticClass: "m__l--5",
              on: { click: _vm.unselectAll }
            },
            [_vm._v("Unselect All")]
          )
        ])
      ]),
      _vm._v(" "),
      _vm.modeDetail
        ? _c("div", { staticClass: "data-page-header-full" })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "data-left-content" },
        _vm._l(_vm.formList, function(item, index) {
          return _c(
            "div",
            {
              key: item.id,
              staticClass: "list-data-content",
              class: { active: _vm.form_id === item.id }
            },
            [
              _c("j-checkbox", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showCheckboxExportTable,
                    expression: "showCheckboxExportTable"
                  }
                ],
                staticClass: "checkbox-oos tick-import-data",
                attrs: { checked: _vm.checkSelected(item.id) },
                on: {
                  input: function($event) {
                    _vm.selectData($event, item)
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "item-data-manager",
                  on: {
                    click: function($event) {
                      _vm.switchForm(item), _vm.setActive(index)
                    }
                  }
                },
                [
                  _c("img", {
                    staticClass: "m__r--10",
                    attrs: {
                      src: require("@/assets/logo/icon-table.svg"),
                      height: "19"
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "info__list-data-content" }, [
                    _c("div", { staticClass: "title__list-data-content" }, [
                      _vm._v(_vm._s(item.name ? item.name : "No Name"))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "id__list-data-content" }, [
                      _vm._v(_vm._s(item.id))
                    ])
                  ])
                ]
              )
            ],
            1
          )
        })
      ),
      _vm._v(" "),
      _vm.modeDetail
        ? _c(
            "div",
            { staticClass: "data-right-update-content" },
            [
              _c("j-form-page-detail", {
                key: _vm.form_id,
                attrs: {
                  "form-id": _vm.form_id,
                  "form-name": _vm.form_name,
                  switcher: _vm.nocode_switcher
                }
              })
            ],
            1
          )
        : _c("div", { staticClass: "data-right-create-content" }, [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showBtnAddTable,
                    expression: "showBtnAddTable"
                  }
                ],
                staticClass: "table-data-manager-btn",
                on: { click: _vm.addFormData }
              },
              [_vm._v("\n      Create Table\n    ")]
            )
          ]),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "appTypeFormDataModal",
          staticClass: "mod-form modal-type-form-data",
          attrs: {
            centered: "",
            "no-close-on-esc": "",
            "no-close-on-backdrop": ""
          }
        },
        [
          _c("div", { staticClass: "label-group-modal text-center" }, [
            _vm._v("CREATE TABLE")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "container-type-list-options" }, [
            _c(
              "div",
              {
                staticClass: "container-option",
                class: _vm.typeMode === "blank" ? "option-active" : "",
                on: {
                  click: function($event) {
                    _vm.selectMode("blank")
                  }
                }
              },
              [
                _vm.typeMode === "blank"
                  ? _c("img", {
                      attrs: { src: require("@/assets/icon/blank-blue.png") }
                    })
                  : _c("img", {
                      attrs: { src: require("@/assets/icon/blank.png") }
                    }),
                _vm._v(" "),
                _c("span", { staticClass: "text-option" }, [
                  _vm._v("Create New Blank")
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "container-option",
                class: _vm.typeMode === "code" ? "option-active" : "",
                on: {
                  click: function($event) {
                    _vm.selectMode("code")
                  }
                }
              },
              [
                _vm.typeMode === "code"
                  ? _c("img", {
                      attrs: { src: require("@/assets/icon/code-blue.png") }
                    })
                  : _c("img", {
                      attrs: { src: require("@/assets/icon/code.png") }
                    }),
                _vm._v(" "),
                _c("span", { staticClass: "text-option" }, [
                  _vm._v("Execute Code")
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", [
                _c(
                  "div",
                  { staticClass: "float-to-right" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btn white m__r--5",
                        on: { click: _vm.closeTypeForm }
                      },
                      [_vm._v("\n            Close\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-button",
                      { staticClass: "btn blue", on: { click: _vm.nextStep } },
                      [_vm._v("\n            Next\n          ")]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "appCodeFormDataModal",
          staticClass: "mod-form modal-code-form-data",
          attrs: {
            centered: "",
            "no-close-on-esc": "",
            "no-close-on-backdrop": ""
          }
        },
        [
          _c("div", { staticClass: "label-group-modal text-center" }, [
            _vm._v("CREATE TABLE")
          ]),
          _vm._v(" "),
          _c("label", [_vm._v(" JSON ")]),
          _vm._v(" "),
          _vm.showCodeEditor
            ? _c("j-monaco-editor", {
                ref: "scriptEditor",
                attrs: { value: _vm.jsonData, language: "json" }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", [
                _c(
                  "div",
                  { staticClass: "float-to-right" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btn white m__r--5",
                        on: { click: _vm.closeCodeForm }
                      },
                      [_vm._v("\n            Close\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-button",
                      {
                        staticClass: "btn blue",
                        on: { click: _vm.createCodeData }
                      },
                      [_vm._v("\n            Next\n          ")]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "appAddFormDataModal",
          staticClass: "mod-form modal-form-ui",
          attrs: {
            centered: "",
            "no-close-on-esc": "",
            "no-close-on-backdrop": ""
          }
        },
        [
          _c("div", { staticClass: "label-group-modal text-center" }, [
            _vm._v("CREATE TABLE")
          ]),
          _vm._v(" "),
          _c(
            "b-form-group",
            { class: { "error-input": _vm.$v.form_data.name.$error } },
            [
              _c("label", [_vm._v(" Name ")]),
              _vm._v(" "),
              _c("j-input", {
                attrs: {
                  "error-required": _vm.$v.form_data.name.$error,
                  "max-length": 255,
                  placeholder:
                    "Only lowercase characters and underscore '_' are allowed, ex: name_table"
                },
                model: {
                  value: _vm.$v.form_data.name.$model,
                  callback: function($$v) {
                    _vm.$set(_vm.$v.form_data.name, "$model", $$v)
                  },
                  expression: "$v.form_data.name.$model"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            {
              class: { "error-input": _vm.$v.form_data.is_offline_mode.$error }
            },
            [
              _c("label", [_vm._v(" Local Storage Support (Offline Mode) ")]),
              _vm._v(" "),
              _c("j-toggle", {
                model: {
                  value: _vm.form_data.is_offline_mode,
                  callback: function($$v) {
                    _vm.$set(_vm.form_data, "is_offline_mode", $$v)
                  },
                  expression: "form_data.is_offline_mode"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", [
                _c(
                  "div",
                  { staticClass: "float-to-right" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btn white m__r--5",
                        on: { click: _vm.closeCreateForm }
                      },
                      [_vm._v("\n            Close\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-button",
                      {
                        staticClass: "btn blue",
                        on: { click: _vm.createFormData }
                      },
                      [_vm._v("\n            Next\n          ")]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "appImportFormDataModal",
          staticClass: "mod-form modal-add-form-data",
          attrs: {
            centered: "",
            "no-close-on-esc": "",
            "no-close-on-backdrop": ""
          }
        },
        [
          _c("div", { staticClass: "label-group-modal text-center" }, [
            _vm._v("IMPORT")
          ]),
          _vm._v(" "),
          _vm.dropboxImportShow
            ? _c("div", { staticClass: "dropbox-oos" }, [
                _c("input", {
                  staticClass: "input-file",
                  attrs: { type: "file", multiple: "" },
                  on: {
                    change: function($event) {
                      _vm.handleFileUpload($event.target.files)
                    }
                  }
                }),
                _vm._v(" "),
                _c("img", {
                  attrs: { src: require("@/assets/form-data/file-dropbox.png") }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "label-dropbox" }, [
                  _vm._v("Drop your file here, or "),
                  _c("span", [_vm._v("browse")])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "label-support-dropbox" }, [
                  _vm._v("Support : JSON")
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", [
                _c(
                  "div",
                  { staticClass: "float-to-right" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btn white",
                        on: { click: _vm.closeImportForm }
                      },
                      [_vm._v("\n            Close\n          ")]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "container-floating-data-manager table",
          class: {
            "show-container-floating-data-manager": _vm.showProperties,
            "hide-container-floating-data-manager": !_vm.showProperties,
            "container-floating-data-manager-long": !_vm.is_sidebar_minimized
          }
        },
        [
          _c("div", { staticClass: "count-data-selected table" }, [
            _vm._v(_vm._s(_vm.selected_rows.length))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "label-data-selected table" }, [
            _vm._v("Selected "),
            _c("br"),
            _vm._v(" Table" + _vm._s(_vm.selected_rows.length > 1 ? "s" : ""))
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showBtnMoveTable,
                  expression: "showBtnMoveTable"
                }
              ],
              staticClass: "btn-move-table",
              on: { click: _vm.openPropMoveTable }
            },
            [
              _c("img", {
                attrs: { src: require("@/assets/icon/move-table.svg") }
              }),
              _vm._v(" Move Table Group\n    ")
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showBtnExportTable,
                  expression: "showBtnExportTable"
                }
              ],
              staticClass: "btn-export-data table",
              on: { click: _vm.exportData }
            },
            [
              _c("img", {
                attrs: { src: require("@/assets/icon/export-data-white.svg") }
              }),
              _vm._v(" Export\n    ")
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "close-data-selected",
              on: { click: _vm.unselectAll }
            },
            [_vm._v("X")]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-popover",
        {
          directives: [
            {
              name: "click-outside",
              rawName: "v-click-outside",
              value: _vm.closePopover,
              expression: "closePopover"
            }
          ],
          ref: "addPopoverRef",
          attrs: {
            show: _vm.addPopoverShow,
            target: "addPopover",
            placement: "bottom"
          },
          on: {
            "update:show": function($event) {
              _vm.addPopoverShow = $event
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "add-data-manager",
              class: { disabled: !_vm.showBtnAddTable },
              on: { click: _vm.createNewBlank }
            },
            [
              _c("div", { staticClass: "w__10" }, [
                _c("img", {
                  attrs: {
                    src: require("@/assets/form-data/new-blank-small.png")
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "m__l--10" }, [
                _vm._v("Create New Blank")
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "add-data-manager",
              class: { disabled: !_vm.showBtnAddTable },
              on: { click: _vm.executeCode }
            },
            [
              _c("div", { staticClass: "w__10" }, [
                _c("img", {
                  attrs: {
                    src: require("@/assets/form-data/execute-code-small.png")
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "m__l--10" }, [_vm._v("Execute Code")])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "add-data-manager",
              class: { disabled: !_vm.showBtnImportTable },
              on: { click: _vm.importTable }
            },
            [
              _c("div", { staticClass: "w__10" }, [
                _c("img", {
                  attrs: { src: require("@/assets/form-data/import-small.png") }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "m__l--10" }, [_vm._v("Import")])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "container-properties-automation",
          class: {
            "show-container-properties-automation": _vm.showPropertiesMove,
            "hide-container-properties-automation": !_vm.showPropertiesMove
          }
        },
        [
          _c(
            "div",
            { staticClass: "d-flex align-items-start justify-content-between" },
            [
              _c("div", { staticClass: "label-log-detail" }, [
                _vm._v("Move Table Group")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "d-flex align-items-center" }, [
                _c(
                  "div",
                  {
                    staticClass: "close-properties-automation",
                    on: { click: _vm.hidePropertiesMove }
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/icon/icon-close-properties.svg"),
                        width: "25"
                      }
                    })
                  ]
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "container-move-table-data-manager" }, [
            _c("div", { staticClass: "m__t--10" }, [
              _vm._v(
                "Selected Table" +
                  _vm._s(_vm.selected_rows.length > 1 ? "s" : "")
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "count-data-selected" }, [
              _vm._v(_vm._s(_vm.selected_rows.length))
            ])
          ]),
          _c("hr"),
          _vm._v(" "),
          _c("b", [
            _vm._v(
              "Move table" +
                _vm._s(_vm.selected_rows.length > 1 ? "s" : "") +
                " to another table group"
            )
          ]),
          _vm._v(" "),
          _c(
            "b-form-group",
            { class: { "error-input": _vm.$v.tableGroup.$error } },
            [
              _c("label", [_vm._v(" Table Group ")]),
              _vm._v(" "),
              _c("j-single-select", {
                attrs: {
                  options: _vm.tableGroupOptions,
                  placeholder: "Select Table Group",
                  "value-format": "object",
                  label: "name"
                },
                model: {
                  value: _vm.$v.tableGroup.$model,
                  callback: function($$v) {
                    _vm.$set(_vm.$v.tableGroup, "$model", $$v)
                  },
                  expression: "$v.tableGroup.$model"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "information-move-table" }, [
            _c("img", {
              staticClass: "m__r--5",
              attrs: {
                src: require("@/assets/icon/warning.png"),
                height: "15",
                width: "15"
              }
            }),
            _vm._v(" "),
            _vm._m(1)
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "privilege-data-manager-access-button",
              class: {
                "show-privilege-data-manager-access-button":
                  _vm.showPropertiesMove,
                "hide-privilege-data-manager-access-button": !_vm.showPropertiesMove
              }
            },
            [
              _c(
                "button",
                {
                  staticClass: "button-border close-prop-2",
                  on: { click: _vm.hidePropertiesMove }
                },
                [_vm._v("\n        Close\n      ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "button-border submit-prop",
                  on: { click: _vm.assignDataGroupTable }
                },
                [_vm._v("\n        Move Table\n      ")]
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("j-progress", {
        ref: "progressMoveTable",
        attrs: {
          "data-kirim": _vm.data_selected,
          "url-api": _vm.url_move_group,
          headers: _vm.headers
        },
        on: { finish: _vm.finishActionMove }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "table-data-manager-logo" }, [
      _c("img", {
        attrs: { src: require("@/assets/logo/data-manager.svg"), height: "100" }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "m__t--10" }, [_vm._v("No Table Selected")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "label-info" }, [_vm._v("Information")]),
      _vm._v(" "),
      _c("div", [
        _vm._v(
          "Before moving the table, make sure your selection. Once moved, you can no longer move the table to another table group"
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-04eb3cba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04eb3cba","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/data-manager/jForm.vue
// module id = null
// module chunks = 